"use client";

import RemotionPlayer from "@/components/landing/RemotionPlayer";
import { ConnectGBPAnimation } from "@/remotion/how-it-works/ConnectGBPAnimation";
import { AiMonitorsAnimation } from "@/remotion/how-it-works/AiMonitorsAnimation";
import { GetNotifiedAnimation } from "@/remotion/how-it-works/GetNotifiedAnimation";
import { ApproveAnimation } from "@/remotion/how-it-works/ApproveAnimation";
import { ReplyPostedAnimation } from "@/remotion/how-it-works/ReplyPostedAnimation";
import type { ComponentType } from "react";

const ANIMATIONS: { component: ComponentType; durationInFrames: number }[] = [
  { component: ConnectGBPAnimation, durationInFrames: 120 },
  { component: AiMonitorsAnimation, durationInFrames: 120 },
  { component: GetNotifiedAnimation, durationInFrames: 120 },
  { component: ApproveAnimation, durationInFrames: 120 },
  { component: ReplyPostedAnimation, durationInFrames: 120 },
];

export default function StepAnimationPlayer({ index }: { index: number }) {
  const anim = ANIMATIONS[index];
  if (!anim) return null;
  return (
    <RemotionPlayer
      component={anim.component}
      durationInFrames={anim.durationInFrames}
      compositionWidth={800}
      compositionHeight={350}
    />
  );
}
